import { useMemo } from "react";
import capitalize from "lodash/capitalize";
import { DocPayload, toJSON } from "~/document";

const DocumentSummary = (props: { doc: DocPayload }) => {
  const summary = useMemo(
    () => Object.fromEntries(Object.entries(toJSON(props.doc)).filter(([_, val]) => val)),
    [props.doc]
  );
  return (
    <div className="rounded bg-[var(--ui-02)] p-5">
      {Object.entries(summary).map(([itemName, itemValue]) => (
        <div key={itemName} className="mb-3 last:mb-0">
          <div className="text-xs font-semibold">{capitalize(itemName)}</div>
          {itemValue instanceof Array ? (
            <div className="text-xs">
              {itemValue.length === 0 ? "None selected" : itemValue.map((a, idx) => <div key={idx}>{a}</div>)}
            </div>
          ) : (
            <div className="text-xs">{(itemValue as any) || "N/A"}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default DocumentSummary;
